import { createContext } from 'react';
import { CardTemplate } from '@shared/scenes/cards/types';

export interface CardTemplateContextType {
  template?: CardTemplate;
}

export const CardTemplateContext = createContext<CardTemplateContextType>({ template: undefined });
